import React, { useEffect, useState } from "react";
import { Person_icon } from "../../assets/img";

import Footer from "../../Component/Footer/Footer";
import { URLS, WEBSOCKET_URL } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import { Toast } from "../../Component/Toast";
// Firebase v9 imports
import { ref, onValue } from "firebase/database";
import { db } from "../../Services/firebase";
import useStoreKv from "../redux/store/useStorekv";
import RawWebSocket from "../../Websocker/RawWebSocket";
import useStore from "../redux/store/useStore";

const Dashboard = () => {
  const { kv, set } = useStoreKv();
  const { role, user } = useStore();
  const Dsahboard = kv.dsahboard || {};
  const activeCount = kv?.onlineCount ?? 0;
  const [formData, setFormData] = useState(Dsahboard);
  // const [activeCount, setActiveCount] = useState(0);
  const [updateCount, setUpdateCount] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setUpdateCount(activeCount);
    }, 1000);

    return () => clearTimeout(timer); // clear old timer
  }, [activeCount]);

  const boxData = [
    {
      title: "Today Withdraw Amount",
      value: `₹ ${formData?.today_withdraw_amount || 0}`,
      bgColor: "#00474333",
      borderColor: "#004743",
      fontColor: "#004743",
    },
    {
      title: "Today Recharge Amount",
      value: `₹ ${formData?.today_recharge_count || 0}`,
      bgColor: "#EB890033",
      borderColor: "#D87E00",
      fontColor: "#D87E00",
    },
    {
      title: "New User Count",
      value: formData?.new_user_count || 0,
      bgColor: "#0085F733",
      borderColor: "#0072D4",
      fontColor: "#0072D4",
      img: Person_icon,
    },

    {
      title: "Today Sales Amount",
      value: `₹ ${formData?.today_sales_amount || 0}`,
      bgColor: "#5E00FF33",
      borderColor: "#6C0FD7",
      fontColor: "#6C0FD7",
    },
    {
      title: "Today Commission Amount",
      value: `₹ ${formData?.today_commission_amount || 0}`,
      bgColor: "#EB890033",
      borderColor: "#D87E00",
      fontColor: "#D87E00",
    },
    {
      title: "Today Winning Amount",
      value: `₹ ${formData?.today_winning_amount || 0}`,
      bgColor: "#00474333",
      borderColor: "#004743",
      fontColor: "#004743",
    },
    {
      title: "Current Users Online",
      value: updateCount || 0,
      bgColor: "#0085F733",
      borderColor: "#0072D4",
      fontColor: "#0072D4",
      img: Person_icon,
    },
  ];

  const getList = async () => {
    try {
      const res = await get(`${URLS?.DASHBOARD}`);
      console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        setFormData(res?.data);
        set("dsahboard", res?.data);
      } else {
        Toast(res?.message || "No data found");
        set("dsahboard", {});
      }
    } catch (err) {
      Toast("Failed to load links");
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    //Websocket connect to online user
    // let Tok = localStorage.getItem("token") || sessionStorage.getItem("token");
    // RawWebSocket.connect(
    //   `${WEBSOCKET_URL}?token=${encodeURIComponent(Tok)}`,
    //   user?.id,
    // );
    // RawWebSocket.listen("connection_update", (e) => {
    //   console.log("online count", e);
    //   setActiveCount(e?.total_users ?? 0);
    // });
    // const activeRef = ref(db, "/active_users");
    // const unsubscribe = onValue(
    //   activeRef,
    //   (snapshot) => {
    //     const data = snapshot.val() || {};
    //     // console.log("📊 Raw active users data:", JSON.stringify(data));
    //     const currentTime = Date.now();
    //     const RECENT_THRESHOLD = 5000; // 15 seconds - shorter for more accuracy
    //     let activeCount = 0;
    //     const activeUsers = [];
    //     Object.entries(data).forEach(([userId, userData]) => {
    //       let lastUpdated;
    //       let isActive = false;
    //       // Handle both data formats
    //       if (userData === true) {
    //         // Old format: {17: true}
    //         lastUpdated = currentTime; // Assume recent
    //         isActive = true;
    //       } else if (userData && typeof userData === "object") {
    //         // New format: {17: {userId: 17, isActive: true, lastUpdated: ...}}
    //         lastUpdated = userData.lastUpdated || 0;
    //         isActive = userData.isActive === true;
    //       } else {
    //         // Invalid format
    //         return;
    //       }
    //       const timeSinceUpdate = currentTime - lastUpdated;
    //       const isRecent = timeSinceUpdate < RECENT_THRESHOLD;
    //       if (isActive && isRecent) {
    //         activeCount++;
    //         activeUsers.push({
    //           userId: userId,
    //           lastUpdated: lastUpdated,
    //           timeSinceUpdate: timeSinceUpdate,
    //         });
    //         // console.log(
    //         //   `✅ ${userId} - ACTIVE (${Math.round(timeSinceUpdate / 1000)}s ago)`,
    //         // );
    //       } else if (isRecent) {
    //         // console.log(
    //         //   `⏸️ ${userId} - INACTIVE but recent (${Math.round(timeSinceUpdate / 1000)}s ago)`,
    //         // );
    //       } else {
    //         // console.log(
    //         //   `💀 ${userId} - STALE (${Math.round(timeSinceUpdate / 1000)}s ago)`,
    //         // );
    //       }
    //     });
    //     // console.log(`📈 TOTAL ACTIVE: ${activeCount} users`);
    //     // console.log(`👥 Active users:`, activeUsers);
    //     setActiveCount(activeCount);
    //   },
    //   (error) => {
    //     console.error("❌ Error reading active users:", error);
    //   },
    // );
    // return () => {
    // unsubscribe();
    // RawWebSocket.disconnect();
    // };
  }, []);

  // console.log("activeCount", activeCount);

  return (
    <div className="dashRightView ">
      <div className="container_overall">
        <div style={{ marginBottom: 80 }} className="row mt-4">
          {boxData.map((box, index) => (
            <div
              style={{ minHeight: 100 }}
              className="col-sm-1 col-md-2 col-lg-2 mb-3 dashboard-container"
              key={index}
            >
              <div
                className=" text-center  dashboard-title h-90 "
                style={{
                  backgroundColor: box.bgColor,
                  border: `1px solid ${box.borderColor}`,
                  color: box.fontColor,
                  padding: 11,
                }}
              >
                <p
                  className=" mb-2 f2 fs-xs-13 fs-sm-11 fs-md-13 fs-lg-13 fs-xl-13 fs-xxl-19 "
                  style={{ wordWrap: "break-word", whiteSpace: "normal" }}
                >
                  {box.title}
                </p>
                <div className="d-flex ac-jc gap-1">
                  {box.img && <img src={box.img} alt="icon" height={20} />}
                  <h5
                    className={` ${box.img ? "fs-xs-17" : "fs-xs-17"} fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mb-0 ${
                      box.img ? "f4" : "f3"
                    }`}
                  >
                    {box.value}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;
